import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { theme } from '../../../themes/default-theme';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ReactSVG } from 'react-svg';
import ArrowRight from '../../../assets/icons/model-arrow-right.svg';

const Wrapper = styled.div`

`

const Container = styled.div`

`

const StepsContainer = styled.div`
    width: 100%;
    ${theme.breakpoints.up('md')} { 
        max-width: 445px;
    }
    ${theme.breakpoints.down('sm')} { 
      
    }
`

const StepContainer = styled.div`
    position: relative;
    > a {
        text-decoration: none;
        font-weight: 800;
        text-transform: uppercase;
        display: block;
        width: 100%;
        height: 100%;
        border-top: 1px solid ${theme.palette.middleGrey};
        > span {
            &:nth-child(2) {
                color: #2E3238;
                margin-left: 3px;
                &:before {
                    content: '-';
                    padding-right: 3px;
                }
            }
        }
        + span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
    }
    &:last-child {
        > a {
            border-bottom: 1px solid ${theme.palette.middleGrey};
        }
    }
    ${theme.breakpoints.up('md')} { 
        > a {
            font-size: 18px;
            line-height: 21px;
            padding: 15px 0;
        }
    }
    ${theme.breakpoints.down('sm')} { 
        > a {
            font-size: 15px;
            line-height: 21px;
            padding: 10px 0;
        }
    }

    ${props => props.active == 1 && `

    > a {
        color: ${theme.palette.vividBlue};
    }
`}
`

const ArrowSvg = styled(ReactSVG)`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
`

const ModelStepsLinks = (props) => {

    const {
        modelStepsData
    } = props;

    const [activeStep, setActiveStep] = useState(null)
    const [disabledStepMsg, setDisabledStepMsg] = useState(false);
    const router = useRouter();

    const handleDisabledStep = (e) => {
        e.preventDefault();
        setDisabledStepMsg(true);
        setTimeout(() => {
            setDisabledStepMsg(false);
        }, 3000)
    }

    useEffect(() => {
        if(modelStepsData?.active) {
            setActiveStep(modelStepsData.active)
        } else {
            setActiveStep(1)
        }
    }, [modelStepsData])

    return (
        <Wrapper>
            <Container>
                {modelStepsData && modelStepsData.steps && modelStepsData.steps.length > 0 &&
                    <StepsContainer>
                        {modelStepsData.steps.map((item, index) => {
                            return (
                                <StepContainer key={index} active={(index + 1) == (activeStep && activeStep) ? 1 : 0}>
                                   
                                        {item.disabled ?
                                            <>
                                                <a onClick={(e) => { handleDisabledStep(e) }}>
                                                    <span>
                                                        {item.step}
                                                    </span>
                                                    <span>
                                                        {item.title}
                                                    </span>
                                                    <ArrowSvg src={ArrowRight} />
                                                </a>
                                                {disabledStepMsg &&
                                                    <span>
                                                       
                                                    </span>
                                                }
                                            </>
                                            :
                                            <Link href={item.url && !item.disabled ? item.url : ''}>
                                                <a>
                                                    <span>
                                                        {item.step}
                                                    </span>
                                                    <span>
                                                        {item.title}
                                                    </span>
                                                    <ArrowSvg src={ArrowRight} />
                                                </a>
                                            </Link>
                                        }
                                    
                                </StepContainer>
                            )
                        })
                        }
                    </StepsContainer>
                }
            </Container>
        </Wrapper>
    )
}

ModelStepsLinks.propTypes = {
    modelStepsData: propTypes.object
}

ModelStepsLinks.defaultProps = {
    modelStepsData: {}
}

export default ModelStepsLinks